<template>
  <button
    type="button"
    class="border-background-fg/20 bg-background relative w-full rounded-md border px-4 py-3 text-sm shadow-sm"
    @click.prevent="$emit('edit')"
  >
    <div class="flex">
      <h2 class="text-base font-semibold">
        {{ customerDisplayName(customer) }}
      </h2>
      <p
        v-if="customer.membershipNumber"
        class="bg-background-fg/8 mx-auto ml-2 inline-flex items-center rounded-full px-2 py-0.5"
      >
        {{ customer.membershipNumber }}
      </p>
      <div class="ml-auto">
        <button
          v-if="allowEdit"
          class="py-.5 rounded-md px-1 font-semibold hover:bg-black hover:bg-opacity-10"
          @click.prevent="$emit('change')"
        >
          Change
        </button>

        <span
          class="py-.5 hover:bg-amber text-amber rounded-md px-1 font-semibold hover:bg-opacity-20"
        >
          Edit
        </span>
      </div>
    </div>
    <div v-if="customer.email || customer.phone" class="mt-1">
      <div v-if="customer.email" class="flex items-center">
        <IconHeroiconsAtSymbol />
        <p class="text-background-fg/50 ml-2">{{ customer.email }}</p>
      </div>
      <div v-if="customer.phone" class="flex items-center">
        <IconHeroiconsSolidPhone />
        <p class="text-background-fg/50 ml-2">{{ customer.phone }}</p>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import {
  customerDisplayName,
  type Customer,
} from "@/services/bookings/customers";

defineProps<{ customer: Customer; allowEdit?: boolean }>();
defineEmits<{
  (event: "edit"): void;
  (event: "change"): void;
}>();
</script>
